import { render, staticRenderFns } from "./detaile.vue?vue&type=template&id=f7107684&scoped=true&"
import script from "./detaile.vue?vue&type=script&lang=js&"
export * from "./detaile.vue?vue&type=script&lang=js&"
import style0 from "./detaile.vue?vue&type=style&index=0&id=f7107684&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7107684",
  null
  
)

export default component.exports